
import './SkillTabs.css'
// import 'animate.css';
import "animate.css/animate.min.css";
import { BsEmojiNeutral } from 'react-icons/bs'
import cLan from '../../../../assets/svgs/cLan.png' //D
import cppLan from '../../../../assets/svgs/cpp.svg' // D
import pyLan from '../../../../assets/svgs/py.svg' // D
import javaLan from '../../../../assets/svgs/java-4.svg' // D
import oop from '../../../../assets/svgs/oop.png' // D
import datastructure from '../../../../assets/svgs/datastructure.png' // D
import algo from '../../../../assets/svgs/algo.png' // D
import machineLearning from '../../../../assets/svgs/machineLearning.png' // D
import jsLan from '../../../../assets/svgs/js.svg' // D
import ts from '../../../../assets/svgs/ts.svg' // D
import html from '../../../../assets/svgs/html.svg'; // D
import css from '../../../../assets/svgs/css.svg'; // D
import sass from '../../../../assets/svgs/sass.svg'; // D
import react from '../../../../assets/svgs/react-2.svg' // D
import nextjs from '../../../../assets/svgs/nextjs.svg' // D
import nodejs from '../../../../assets/svgs/nodejs-1.svg' // D
import expressjs from '../../../../assets/svgs/express.svg' // D
import mongodb from '../../../../assets/svgs/mongodb.svg' // D
import mysql from '../../../../assets/svgs/mysql.svg' // D
import restAPI from '../../../../assets/svgs/restAPI.png' // D
import bootstrap from '../../../../assets/svgs/bootstrap.svg' // D
import materialui from '../../../../assets/svgs/material-ui.svg' // D
import figma from '../../../../assets/svgs/figma.svg'
import adobePhotoshop from '../../../../assets/svgs/adobePhotoshop.svg' //D
import redux from '../../../../assets/svgs/redux.svg' //D
import reactQuery from '../../../../assets/svgs/reactQuery.png' // D
import php from '../../../../assets/svgs/php.svg' // D
import vsCode from '../../../../assets/svgs/vsCode.svg' // D
import github from '../../../../assets/svgs/github.svg' // D
import git from '../../../../assets/svgs/git.svg' // D
import jira from '../../../../assets/svgs/jira.svg' // D
import clickup from '../../../../assets/svgs/clickup.svg' // D
import discord from '../../../../assets/svgs/discord.svg' // D
import xampp from '../../../../assets/svgs/xampp.svg' // D
import jupyter from '../../../../assets/svgs/jupyter.png' // D
import keras from '../../../../assets/svgs/keras.png' // D
import tensorflow from '../../../../assets/svgs/tensorflow.svg' // D
import npm from '../../../../assets/svgs/npm.svg' //D


export const SkillTab_for_original_selectBodyMessage = () => {
    return(
        <div className='SkillTab_for_original_selectBodyMessage-wrapper'>
           <p> Select my <strong>Muscular</strong> body parts to see my skills.</p>
        </div>
    )
}


export const SkillTab_for_head_coding = () => {
    
        return (
          <>
            {/* <div className='skillTab-wrapper'> */}
            <h2 style={{ color: "blue", fontWeight: "800" }}>Programming:</h2>
            <h3>Language</h3>
            <div className="skillTab_for_coding animate__animated ">
              <img
                className="animate__animated animate__backInDown"
                src={cLan}
                alt="c-language"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
              <img
                className="animate__animated animate__backInLeft"
                src={cppLan}
                alt="cpp-language"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
              <img
                className="animate__animated animate__backInRight"
                src={pyLan}
                alt="py-language"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
              <img
                className="animate__animated animate__backInUp"
                src={javaLan}
                alt="java-language"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
              <img
                className="animate__animated animate__bounceIn"
                src={jsLan}
                alt="js-language"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
            </div>
            <h3>Knowledge</h3>
            <div className="skillTab_for_coding animate__animated">
              <img
                className="animate__animated animate__bounceInDown"
                src={oop}
                alt="oop"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
              <img
                className="animate__animated animate__bounceInLeft"
                src={datastructure}
                alt="datastructure"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
              <img
                className="animate__animated animate__bounceInRight"
                src={algo}
                alt="algo"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
              <img
                className="animate__animated animate__bounceInUp"
                src={machineLearning}
                alt="machineLearning"
                style={{
                  margin: "1vw",
                  width: "4vw",
                  height: "8vh",
                  borderRadius: "25%",
                }}
              />
            </div>
            {/* </div> */}
          </>
        );

}
export const SkillTab_for_rightArm_frontEnd = () => {
    
        return (
          <>
            <div>
              <h2 style={{ color: "blue", fontWeight: "800" }}>Front End:</h2>
              <h3>Development</h3>
              <div className="skillTab_for_coding animate__animated animate__backInDown">
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeIn"
                  src={html}
                  alt="html"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInDown"
                  src={jsLan}
                  alt="js-language"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInDownBig"
                  src={ts}
                  alt="ts-language"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInLeft"
                  src={react}
                  alt="react"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInLeftBig"
                  src={nextjs}
                  alt="nextjs"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInRight"
                  src={redux}
                  alt="redux"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInRightBig"
                  src={reactQuery}
                  alt="reactQuery"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInUp"
                  src={npm}
                  alt="npm"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
              </div>
              <h3>Styling</h3>
              <div className="skillTab_for_coding animate__animated animate__backInDown">
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInUpBig"
                  src={css}
                  alt="css"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInTopLeft"
                  src={sass}
                  alt="sass"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInTopRight"
                  src={bootstrap}
                  alt="bootstrap"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInBottomLeft"
                  src={materialui}
                  alt="materialui"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
              </div>
            </div>
          </>
        );

}
export const SkillTab_for_leftArm_backEnd = () => {
    
        return (
          <>
            <div>
              <h2 style={{ color: "blue", fontWeight: "800" }}>
                Back End Development Stack
              </h2>
              <div className="skillTab_for_coding animate__animated animate__backInDown">
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__fadeInBottomRight"
                  src={nodejs}
                  alt="nodejs"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__flip"
                  src={expressjs}
                  alt="expressjs"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__flipInX"
                  src={php}
                  alt="php"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__flipInY"
                  src={npm}
                  alt="npm"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
              </div>
            </div>
          </>
        );

}
export const SkillTab_for_chest_database = () => {
    
        return (
          <>
            <div>
              <h2 style={{ color: "blue", fontWeight: "800" }}>
                Database Stack
              </h2>
              <div className="skillTab_for_coding animate__animated">
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__flip"
                  src={mysql}
                  alt="mysql"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__flipInX"
                  src={mongodb}
                  alt="mongodb"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__flipInY"
                  src={restAPI}
                  alt="restAPI"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
              </div>
            </div>
          </>
        );

}
export const SkillTab_for_pack_webHelpingTools = () => {
    
        return (
          <>
            <div>
              <h2 style={{ color: "blue", fontWeight: "800" }}>
                Web Development Helping Tools
              </h2>
              <div className="skillTab_for_coding animate__animated animate__backInDown">
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__lightSpeedInRight"
                  src={git}
                  alt="git"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__lightSpeedInLeft"
                  src={github}
                  alt="github"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__rotateIn"
                  src={figma}
                  alt="figma"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__rotateInUpLeft"
                  src={adobePhotoshop}
                  alt="adobePhotoshop"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animatedanimate__rotateIn"
                  src={vsCode}
                  alt="vsCode"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
              </div>
            </div>
          </>
        );

}
export const SkillTab_for_undi_forbiddenPart = () => {
    
        return (
          <>
            <div className=" SkillTab_for_original_selectBodyMessage-wrapper animate__animated animate__jackInTheBox">
              <p>
                {" "}
                <strong>
                  You naughty!! <BsEmojiNeutral/><br />
                </strong>{" "}
                Select my other body parts to see my skills.
              </p>
            </div>
          </>
        );

}
export const SkillTab_for_leg_otherSkills = () => {
    
        return (
          <>
            <div>
              <h2 style={{ color: "blue", fontWeight: "800" }}>Other Skills</h2>
              <div className="skillTab_for_coding animate__animated animate__backInDown">
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__zoomIn"
                  src={jira}
                  alt="jira"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__zoomInDown"
                  src={clickup}
                  alt="clickup"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__zoomInLeft"
                  src={discord}
                  alt="discord"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__zoomInRight"
                  src={xampp}
                  alt="xampp"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />

                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__zoomInUp"
                  src={jupyter}
                  alt="jupyter"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__slideInDown"
                  src={tensorflow}
                  alt="tensorflow"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
                <img
                  // ref={billBoard_gardenRef}
                  className="animate__animated animate__slideInLeft"
                  src={keras}
                  alt="keras"
                  style={{
                    margin: "1vw",
                    width: "4vw",
                    height: "8vh",
                    borderRadius: "25%",
                  }}
                />
              </div>
            </div>
          </>
        );

}
export const SkillTab_for_whole_allSkills = () => {
    
        return(
            <>
            <div>
                <h1>My All Technical Skill Sets</h1>
                <SkillTab_for_head_coding/>
                <SkillTab_for_rightArm_frontEnd/>
                <SkillTab_for_leftArm_backEnd/>
                <SkillTab_for_chest_database/>
                <SkillTab_for_pack_webHelpingTools/>
                <SkillTab_for_leg_otherSkills/>
              </div>
              
        </>
        )

}
